import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { rovoEntitlementResource } from '@jira/router-resources__rovo-entitlement/src/useRovoEntitlementResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskJourneysRoute } from '@jira/router-routes__project-settings-service-desk-journeys-routes/src/projectSettingsServicedeskJourneysRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { journeysPageEntryPoint } from './ui/journeys/index.tsx';

export const projectSettingsServicedeskJourneysRouteEntry: Route = createEntry(
	projectSettingsServicedeskJourneysRoute,
	() => ({
		group: 'project-settings-servicedesk',
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		meta: {
			reporting: {
				id: 'jsm.journey-builder.journeys-list',
				packageName: camelCase('journeys-list'),
				teamName: 'JSM Grape Soju',
			},
		},
		layout: serviceProjectLayout,
		resources: [
			...getServiceDeskSettingsResources(),
			resourceWithCondition(() => fg('enable-jsm-rovo-service-hr-agent'), rovoEntitlementResource),
		],
		perfMetricKey: 'jsm-journeys',
		entryPoint: () => journeysPageEntryPoint,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
